import React from 'react';

interface Props {
  message: string;
}

const NotFound: React.FC<Props> = (props: Props) => {
  const message = props.message;
  return <div> {message}</div>;
};

export default NotFound;
